import { Link } from "react-router-dom";
import { Card, Typography } from "@/components/ui/atoms";
import type { BlogPostViewModel } from "../../types";
import { formatLongDate } from "@/utils/date";
import { getBlogPrimaryImage } from "../../utils";

interface RelatedListProps {
  posts: BlogPostViewModel[];
  currentSlug?: string;
}

export function RelatedList({ posts, currentSlug }: RelatedListProps) {
  const items = posts.filter((post) => post.slug !== currentSlug).slice(0, 3);
  if (items.length === 0) return null;

  return (
    <Card variant="elevated">
      <Typography as="h3" variant="body-md" weight="semibold" color="primary">
        More Articles
      </Typography>
      <div className="mt-3 space-y-3">
        {items.map((post) => {
          const imageSrc = getBlogPrimaryImage(post);

          return (
          <article key={post.documentId} className="group flex gap-3">
            {imageSrc ? (
              <img
                src={imageSrc}
                alt={post.coverImageAlt || post.title}
                className="h-14 w-20 rounded-md object-cover transition-transform duration-200 group-hover:scale-[1.02]"
                loading="lazy"
              />
            ) : null}
            <div className="min-w-0">
              <Link to={`/blog/${post.slug}`} className="line-clamp-2 text-[13px] leading-5 text-dark-invirtus transition-colors hover:text-dark-invirtus/85">
                {post.title}
              </Link>
              <Typography as="p" variant="body-xs" color="muted" >
                {formatLongDate(post.publishedAt || post.createdAt)}
              </Typography>
            </div>
          </article>
          );
        })}

        {items.length > 2 ? (
          <Link
            to="/blog"
            className="inline-flex text-xs font-semibold text-purple transition-colors hover:text-purple/85"
          >
            See more
          </Link>
        ) : null}
      </div>
    </Card>
  );
}
